var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.400391C4.53762 0.400391 0.5 4.26195 0.5 9.00664C0.5 11.2662 1.52994 14.2711 3.56112 17.938C5.19237 20.8821 7.07956 23.5445 8.06112 24.8691C8.22699 25.0955 8.44385 25.2796 8.69413 25.4064C8.94442 25.5333 9.22108 25.5994 9.50169 25.5994C9.7823 25.5994 10.059 25.5333 10.3092 25.4064C10.5595 25.2796 10.7764 25.0955 10.9423 24.8691C11.9221 23.5445 13.811 20.8821 15.4423 17.938C17.4701 14.2722 18.5 11.2673 18.5 9.00664C18.5 4.26195 14.4624 0.400391 9.5 0.400391ZM9.5 13.0004C8.78799 13.0004 8.09196 12.7893 7.49995 12.3937C6.90793 11.9981 6.44651 11.4359 6.17403 10.7781C5.90156 10.1202 5.83027 9.3964 5.96917 8.69807C6.10808 7.99973 6.45095 7.35827 6.95442 6.85481C7.45788 6.35134 8.09934 6.00847 8.79768 5.86956C9.49601 5.73066 10.2198 5.80195 10.8777 6.07442C11.5355 6.3469 12.0977 6.80832 12.4933 7.40034C12.8889 7.99235 13.1 8.68838 13.1 9.40039C13.099 10.3548 12.7193 11.2699 12.0444 11.9448C11.3695 12.6197 10.4545 12.9993 9.5 13.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDetailsIcon);
export default __webpack_public_path__ + "static/media/ServiceDetailsIcon.b1fd2f9b81c033eb701ab7bf32aa07e0.svg";
export { ForwardRef as ReactComponent };